// removed by extract-text-webpack-plugin
module.exports = {"fadeinOutD6":"core__fadeinOutD6___3Iht8","fadeinOutD13":"core__fadeinOutD13___3GWYC","progress-bar-stripes":"core__progress-bar-stripes___2GWre"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/core.scss
// module id = 2137
// module chunks = 14